<template>
  <div class="section-join-us" data-aos="fade">
    <b-container>
      <b-row>
        <b-col sm="12" md="8">
          <div class="d-md-flex align-items-center h-100">
            <p>{{ $t("sectiongallery") }}</p>
          </div>
        </b-col>
        <b-col sm="12" md="4">
          <div class="d-md-flex align-items-center justify-content-end h-100">
            <router-link :to="{ name: 'gallery' }">
              <button-link text="joinus" />
            </router-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ButtonLink from "@/components/layout/ButtonLink.component.vue";
export default {
  components: { ButtonLink },
};
</script>
